export const TAX_RATE = 0.075; // 7.5% 
export const MENU = [
  {
    id: 1,
    name: "Kung Pao Brussels",
    description: "Almond Chimichurri, Gochujang Mayo, Crunchy Garlic",
    price: 8.5,
    category: "For Sharing",
  },
  // {
  //   id: 2,
  //   name: "Crispy Deviled Eggs",
  //   description: "Crispy Whites, Miso Mayo, Chili Crisp",
  //   price: 8,
  //   category: "For Sharing",
  // },
  {
    id: 3,
    name: "Kimchi Grilled Cheese",
    description: "Local Kimchi, Mozzarella, Gochujang Mayo, on Fresh Sourdough.",
    price: 14,
    category: "Handhelds",
  },
  {
    id: 4,
    name: "Nashville Chicken Sliders",
    description: "Crispy Chicken Thigh, Nashville Sauce, Kimchi Ranch, Quickles, on Fresh Japanese Milkbread.",
    price: 15,
    category: "Handhelds",
  },
  {
    id: 5,
    name: "Miso Bean Toast",
    description: "Miso Leeks, Cannelini Beans, Thicc Foccacia, Soft Boiled Egg, Chili Crisp",
    price: 15,
    category: "Handhelds",
  },
  {
    id: 6,
    name: "Pork Belly Sliders",
    description: "Korean Bbq Pork Belly, Cilantro Mayo, Quickles, on Fresh Japanese Milk Bread",
    price: 16,
    category: "Handhelds",
  },
  // {
  //   id: 7,
  //   name: "Crispy Redfish",
  //   description: "Pan Fried Redfish, Korean Tartar, Aged White Cheddar, on Fresh Japanese Milkbread Sesame Bun",
  //   price: 16,
  //   category: "Handhelds",
  // },
  {
    id: 8,
    name: "Kung Pao Brussels Sprouts",
    description: "Almond Chimichurri, Gochujang Mayo, Crunchy Garlic",
    price: 5,
    category: "Sides",
  },
  {
    id: 9,
    name: "Smashed Potatoes",
    description: "Crispy gold poato, kimchi butter, pecorino romano",
    price: 4,
    category: "Sides",
  },
  {
    id: 10,
    name: "Yuzu Caesar",
    description: "Dino Kale, Crunchy Garlic, Yuzu Caesar Dressing",
    price: 4,
    category: "Sides",
  },
  //  {
  //   id: 11,
  //   name: "Collard Greens",
  //   description: "Coconut Milk Broth, Crunchy Garlic",
  //   price: 5,
  //   category: "Sides",
  // },
  //  {
  //   id: 12,
  //   name: "Pomelo Salad",
  //   description: "Pomelo, Mint, Thai Basil, Lemongrass, Shallot, Aji Amarillo Dressing, Toasted Rice",
  //   price: 5,
  //   category: "Sides",
  // },
  {
    id: 13,
    name: "Cold Sesame Noodles",
    description: "Fresh Pasta, Sesame Vinaigrette, Pickled veggies",
    price: 4,
    category: "Sides",
  },
  // {
  //   id: 14,
  //   name: "The Ragu (Light Portion)",
  //   description: "Fresh Tagliatelle Pasta, Pancetta & Beef Ragu, Miso, Citrus, Crunchy Garlic, Parmigiano Reggiano",
  //   price: 16,
  //   category: "Bowls",
  // },
  {
    id: 22,
    name: "Blackened Fish",
    description: "Blackened Flounder, Gochujang Risotto, Yuzu Cream Sauce",
    price: 20,
    category: "Bowls",
  },
   {
    id: 15,
    name: "Steak N, Kimchi Fried Rice",
    description: "Wok Seared Beef, Kimchi, Egg, Onion, Kung pao, Gochujang, Sesame Seeds",
    price: 17,
    category: "Bowls",
  },
   {
    id: 16,
    name: "Plant Bibimbap Bowl",
    description: "Crispy Rice, Sauteed Dino Kale, Kung Pao Brussels, Cherry Tomato, Pickled Veggies, Sesame Lentil Tabouleh, Almond Chimichurri, Sesame Seed, Fried Egg, Gochujang",
    price: 15,
    category: "Bowls",
  },
   {
    id: 17,
    name: "Pork Belly Bowl",
    description: "Korean BBQ Pork Belly, Cold Sesame Egg Noodles, Pickled Veggies",
    price: 16,
    category: "Bowls",
  },
   {
    id: 18,
    name: "Orange Beignets",
    description: "Chili Garlic Honey",
    price: 6,
    category: "Dessert",
  },
  // {
  //   id: 19,
  //   name: "Key Lime Pie",
  //   description: "Served with whipped cream",
  //   price: 5,
  //   category: "Dessert",
  // },
  //   {
  //   id: 20,
  //   name: "Whole Roasted Chicken",
  //   description: "Lemongrass & Cilantro Rub, Honey Basted, Side of Basting Jus",
  //   price: 46,
  //   category: "Main",
  // },
    {
    id: 21,
    name: "Slow Roasted Pork Shoulder",
    description: "Korean BBQ Glaze, Side of BBQ Sauce",
    price: 60,
    category: "Main",
  },
];

